import { getParam, get, post } from './httpServer';

export default {
  findAll(params) {
    return getParam('/api/user/order/', params);
  },
  getOne(id) {
    return get(`/api/user/order/detail/${id}/`);
  },
  applyRefund(id) {
    return post('/api/user/order/refund/', { order_id: id });
  },
};



// WEBPACK FOOTER //
// ./src/service/order.js